<script setup>
import { ref } from "vue"

const props = defineProps({
    contentClass: {
        type: String,
        default: ''
    },
    buttonClass: {
        type: String,
        default: ''
    },
    clickToClose: {
        type: Boolean,
        default: true
    },
    outsideClickToClose: {
        type: Boolean,
        default: true
    },
    escToClose: {
        type: Boolean,
        default: true
    },
})

const isOpen = ref(false)


// Accessibility.
const dropdownContent = ref(null)

const onShow = (e) => {

    if (e.target.closest('[no-close]')) {
        return
    }

    if (!props.outsideClickToClose) {
        return
    }

    if (dropdownContent.value && !dropdownContent.value.contains(e.target)) {
        isOpen.value = false
    }

    hide()
}

const show = () => {
    isOpen.value = true

    setTimeout(() => {
        document.addEventListener('click', onShow)
    }, 100)
}

const hide = () => {
    if (!props.clickToClose) return
    
    isOpen.value = false

    document.removeEventListener('click', onShow)
}

const toggle = () => {
    if (isOpen.value) {
        hide()
    } else {
        show()
    }
}

</script>

<template>
    <div ref="dropdownContent" class="relative rounded-lg" v-bind="$attrs">
        <div :class="props.buttonClass" @click.prevent="toggle" tabindex="1" class="flex outline-none" @keydown.esc="props.escToClose ? hide() : ''">
            <slot></slot>
        </div>

        <transition name="slide-fade">
            <div ref="content" class="overflow-hidden absolute z-50 bg-white shadow-[0px_4px_6px_-2px_rgba(16,24,40,0.03),0px_12px_16px_-4px_rgba(16,24,40,0.08)] border border-[#EAECF0] py-1 rounded-lg" v-if="isOpen && $slots.content" :class="props.contentClass">
                <slot name="content"></slot>
            </div>
        </transition>
    </div>
</template>

